import { CrisisAlertOutlined, SavingsOutlined } from '@mui/icons-material';
import { Zeros } from '../Icons';
import { CampaignCalculator, CampaignTargets } from '../RightSection';
import Section from './Section';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { useEffect } from 'react';
import { DURATION_SECONDS, RIGHT_SECTION_LABEL } from '../../constants';
import { updateField } from '../../redux/features/campaignDetail/campaignDetailSlice';
import { REDUX_KEY } from '../../redux/constants';

const RightSection = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { detail, burst } = useAppSelector((state: RootState) => state);

  const calculateUsedBudget = () => {
    let totalCalculatedBudget = 0;
    let totalCalculatedTarps = 0;
    let totalCalculatedImpacts = 0;

    Object.entries(detail.campaignDurations).map(
      ([duration, isBurstSelected]) => {
        const durationSeconds = duration as DURATION_SECONDS;
        if (isBurstSelected) {
          totalCalculatedBudget += burst[durationSeconds].calculatedTotalBudget;
          totalCalculatedTarps += burst[durationSeconds].calculatedTotalTarps;
          totalCalculatedImpacts +=
            burst[durationSeconds].calculatedTotalImpact;
        }
      }
    );

    dispatch(
      updateField({
        fieldName: REDUX_KEY.USED_BUDGET,
        value: totalCalculatedBudget
      })
    );
    dispatch(
      updateField({
        fieldName: REDUX_KEY.USED_TARPS,
        value: totalCalculatedTarps
      })
    );
    dispatch(
      updateField({
        fieldName: REDUX_KEY.USED_IMPACTS,
        value: totalCalculatedImpacts
      })
    );
  };

  useEffect(() => {
    calculateUsedBudget();
  }, [burst]);

  return (
    <>
      {location.pathname !== '/' &&
        location.pathname !== '/fourth' &&
        detail.campaignLength.startDate !== null &&
        detail.campaignLength.endDate !== null && (
          <Section minWidth="424px" padding="40px">
            {location.pathname === '/third' && (
              <>
                <CampaignTargets
                  label={RIGHT_SECTION_LABEL.BUDGET}
                  icon={<SavingsOutlined />}
                  usedValue={detail.usedBudget}
                  totalValue={detail.grossBudget}
                  durations={detail.campaignDurations}
                />
                <CampaignTargets
                  label={RIGHT_SECTION_LABEL.IMPACT}
                  icon={<Zeros />}
                  usedValue={detail.usedImpacts}
                  totalValue={detail.targetImpact}
                  durations={detail.campaignDurations}
                />
                <CampaignTargets
                  label={RIGHT_SECTION_LABEL.TARPS}
                  icon={<CrisisAlertOutlined />}
                  usedValue={detail.usedTarps}
                  totalValue={detail.targetTarp}
                  durations={detail.campaignDurations}
                />
              </>
            )}
            {detail.campaignLength.startDate &&
              detail.campaignLength.endDate && (
                <CampaignCalculator
                  startDate={detail.campaignLength.startDate}
                  endDate={detail.campaignLength.endDate}
                />
              )}
          </Section>
        )}
    </>
  );
};

export default RightSection;
